function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "5.35 4.8 414.1 269.1",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "419.39 151.08 320.35 151.08 419.39 243.41 419.39 271.18 331.99 190.2 212.39 273.83 212.39 243.41 314.07 173.14 290.22 151.08 212.39 151.08 212.39 151.08 5.39 151.08 5.39 127.08 104.3 127.08 5.39 35.28 5.39 7.51 92.8 88.49 212.39 4.86 212.39 35.28 110.65 105.28 134.43 127.08 212.39 127.08 212.39 127.08 419.39 127.08 419.39 151.08",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -85.60965, -152.921051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.75,246h3v26h-3v-2.16h-.07a4.51,4.51,0,0,1-4.17,2.52c-2.92,0-5.87-1.15-5.87-9.14,0-4.54.14-9.76,6-9.76a4.62,4.62,0,0,1,4,2.2h.1Zm-3.42,9.87c-3.16,0-3.6,2.51-3.6,7.37,0,2.74,0,6.7,3.71,6.7,3.31,0,3.31-4.1,3.31-7.78C252.75,259.75,252.61,255.87,249.33,255.87Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.64,263.17c0-5.32.61-9.72,6.91-9.72s6.91,4.4,6.91,9.72c0,8-3.06,9.18-6.91,9.18S260.64,271.2,260.64,263.17Zm10.73-1.26c0-5-1.55-6-3.82-6s-3.82,1.08-3.82,6c0,5.91.76,8,3.82,8S271.37,267.82,271.37,261.91Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.86,253.81h2.95v14.4c0,1.26.07,2.52.18,3.78h-3.13V269.8h-.11a5.22,5.22,0,0,1-4.6,2.55c-3.17,0-4.9-1.58-4.9-4.68V253.81h2.95v12.6c0,2.2,1,3.67,3.1,3.67,1.58,0,3.56-1.18,3.56-4.21Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.35,272h-3V246h3v9.65h.1a4.62,4.62,0,0,1,4-2.2c5.87,0,6,5.22,6,9.76,0,8-2.95,9.14-5.87,9.14a4.51,4.51,0,0,1-4.17-2.52h-.07Zm3.31-2.05c3.71,0,3.71-4,3.71-6.7,0-4.86-.44-7.37-3.6-7.37s-3.42,3.88-3.42,6.29C300.35,264.94,300,269.94,303.66,269.94Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,272h-2.95V246H318Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,263.86c0,5.07,1.37,6.08,3.67,6.08,2,0,3.06-1.62,3.17-3.46h3.24c0,4-2.52,5.87-6.33,5.87s-6.91-1.15-6.91-9.18c0-5.32.61-9.72,6.91-9.72,5.18,0,6.48,2.85,6.48,8.86v1.55Zm7.09-2.24c0-5.29-1.47-5.93-3.63-5.93-1.87,0-3.42.89-3.46,5.93Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.08,272h-2.95V246h2.95v15.66h.08l5.54-7.85h3.6l-6.05,7.81L354.38,272h-3.74l-6.48-10.19h-.08Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.48,269.36h-.08a4.45,4.45,0,0,1-4.57,3c-3.85,0-5-2.48-5-6,0-5.51,5.39-5.76,9.53-5.66.08-2.41.11-5-3.06-5a2.68,2.68,0,0,0-2.84,3.23h-3.2c.14-4.06,2.3-5.47,6.15-5.47,4.68,0,5.91,2.42,5.91,5.47v8.75a28.19,28.19,0,0,0,.36,4.32h-3.24Zm-6.66-2.77c0,1.77.86,3.35,2.84,3.35,1.8,0,4-1.12,3.74-7C363.6,263,359.82,262.74,359.82,266.59Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.84,253.81h3v14.4c0,1.26.07,2.52.18,3.78h-3.13V269.8h-.11a5.23,5.23,0,0,1-4.61,2.55c-3.17,0-4.9-1.58-4.9-4.68V253.81h3v12.6c0,2.2,1,3.67,3.09,3.67,1.59,0,3.57-1.18,3.57-4.21Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.73,246h2.95v26h-2.95v-2.16h-.07a4.51,4.51,0,0,1-4.18,2.52c-2.92,0-5.87-1.15-5.87-9.14,0-4.54.15-9.76,6-9.76a4.62,4.62,0,0,1,4,2.2h.11Zm-3.42,9.87c-3.17,0-3.6,2.51-3.6,7.37,0,2.74,0,6.7,3.71,6.7,3.31,0,3.31-4.1,3.31-7.78C402.73,259.75,402.58,255.87,399.31,255.87Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.87,246h3.31v3.17h-3.31ZM414,272h-3V253.81h3Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.6,263.17c0-5.32.62-9.72,6.92-9.72s6.91,4.4,6.91,9.72c0,8-3.06,9.18-6.91,9.18S418.6,271.2,418.6,263.17Zm10.73-1.26c0-5-1.55-6-3.81-6s-3.82,1.08-3.82,6c0,5.91.76,8,3.82,8S429.33,267.82,429.33,261.91Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.2,272h-3.38v-3.74h3.38Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.6,259.64c.07-3-1.4-3.77-2.52-3.77-2.27,0-3.81,1.08-3.81,6,0,5.91.75,8,3.81,8,.69,0,2.74-.72,2.63-4h3.1c.1,5.12-3.71,6.41-5.73,6.41-3.85,0-6.91-1.15-6.91-9.18,0-5.32.61-9.72,6.91-9.72,3.64,0,5.76,2.13,5.58,6.19Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.6,263.17c0-5.32.61-9.72,6.91-9.72s6.91,4.4,6.91,9.72c0,8-3.06,9.18-6.91,9.18S462.6,271.2,462.6,263.17Zm10.72-1.26c0-5-1.55-6-3.81-6s-3.82,1.08-3.82,6c0,5.91.76,8,3.82,8S473.32,267.82,473.32,261.91Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,272v-12.6c0-1.83-.51-3.52-2.88-3.52a3.43,3.43,0,0,0-2.56,1.22,5.4,5.4,0,0,0-.68,2.66V272h-3v-14.4c0-1.26-.08-2.52-.18-3.78h3.13v2.27H484c.86-1.94,2.41-2.63,4.53-2.63,1.66,0,3.57.69,4.25,2.34a4.37,4.37,0,0,1,4.32-2.34c1.91,0,5,.44,5,4.72V272H499.1v-12.6c0-1.83-.51-3.52-2.88-3.52a2.65,2.65,0,0,0-2.23.68c-.87.72-1,2.52-1,3.2V272Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -85.60965, -152.921051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.1,339H93.15V313H96.1v15.66h.07l5.54-7.85h3.6l-6,7.81L106.39,339h-3.74L96.17,328.8H96.1Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6,335.61h.07l4.36-14.8h3.2L114,345.87h-3.06l2-6.88-6.15-18.18h3.42Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,339H125V313H128Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,330.86c0,5.07,1.37,6.08,3.68,6.08,2,0,3.05-1.62,3.16-3.46h3.24c0,4-2.52,5.87-6.33,5.87s-6.91-1.15-6.91-9.18c0-5.32.61-9.72,6.91-9.72,5.18,0,6.48,2.85,6.48,8.86v1.55Zm7.1-2.24c0-5.29-1.48-5.93-3.64-5.93-1.87,0-3.42.89-3.46,5.93Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.06,339h-3V313h3v15.66h.07l5.54-7.85h3.6l-6.05,7.81L164.35,339h-3.74l-6.48-10.19h-.07Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.81,320.81h2.95v14.4c0,1.26.07,2.52.18,3.78h-3.13v-2.2h-.11a5.22,5.22,0,0,1-4.61,2.56c-3.17,0-4.89-1.58-4.89-4.68V320.81h3v12.6c0,2.2,1,3.67,3.09,3.67,1.59,0,3.57-1.18,3.57-4.21Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.15,323.55h.07c1.22-2.77,2.74-3.1,5.61-3.1v3.06l-.79-.1a4.8,4.8,0,0,0-.79-.08c-3.27,0-4.1,2.49-4.1,4.93V339h-3V320.81h3Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,323.51l-8,13.07h8.28V339H195.74v-2.77l7.92-12.92v-.08h-7.52v-2.41H207Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.17,339h-3.38v-3.74h3.38Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.57,326.64c.07-3-1.4-3.77-2.52-3.77-2.26,0-3.81,1.08-3.81,6,0,5.91.75,8,3.81,8,.69,0,2.74-.72,2.63-4h3.1c.1,5.11-3.71,6.41-5.73,6.41-3.85,0-6.91-1.15-6.91-9.18,0-5.32.61-9.72,6.91-9.72,3.64,0,5.76,2.13,5.58,6.19Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57,330.17c0-5.32.61-9.72,6.91-9.72s6.91,4.4,6.91,9.72c0,8-3.06,9.18-6.91,9.18S236.57,338.2,236.57,330.17Zm10.72-1.26c0-5-1.54-6-3.81-6s-3.82,1.08-3.82,6c0,5.91.76,8,3.82,8S247.29,334.82,247.29,328.91Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,339v-12.6c0-1.83-.51-3.52-2.88-3.52a3.43,3.43,0,0,0-2.56,1.22,5.4,5.4,0,0,0-.68,2.66V339h-2.95v-14.4c0-1.26-.08-2.52-.18-3.78h3.13v2.27H258c.86-1.94,2.41-2.63,4.54-2.63,1.65,0,3.56.69,4.24,2.34a4.37,4.37,0,0,1,4.32-2.34c1.91,0,5,.43,5,4.72V339h-2.95v-12.6c0-1.83-.51-3.52-2.88-3.52a2.65,2.65,0,0,0-2.23.68c-.87.72-1,2.52-1,3.2V339Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKklogo);
export default __webpack_public_path__ + "static/media/kklogo.15289a62ae064f22e96a392984b1bc2a.svg";
export { ForwardRef as ReactComponent };